const extractContactInfo = (doc, label) => {
  const element = Array.from(doc.querySelectorAll('div')).find((div) => {
    const text = div.textContent.trim();
    return text.startsWith(label);
  });

  return element?.querySelector('a')?.textContent.trim() || '';
};

export const parseCombinedData = (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  const title = doc.querySelector('h3')?.textContent || '';

  const messageParagraphs = Array.from(doc.querySelectorAll('div > p'))
    .map((p) => p.textContent)
    .join('\n');

  const phone = extractContactInfo(doc, 'Телефон');
  const url = extractContactInfo(doc, 'Сайт');
  const email = extractContactInfo(doc, 'Email');
  const address = extractContactInfo(doc, 'Адрес');

  return {
    title,
    message: messageParagraphs,
    phone: phone.split('+7')[1] || '',
    url,
    email,
    address,
  };
};
